import { Modal, Notification } from "@cea/ui-kit";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/client";

import {
  DELETE_ESGT_FILE,
  DELETE_ESGT_FOLDER,
} from "../../queries/esgServices";
import { getNotification } from "../../utils";

const useFileFolderDeleteDialog = ({ onFileDelete, onFolderDelete }) => {
  const [deleteESGTFile] = useMutation(DELETE_ESGT_FILE);
  const [deleteESGTFolder] = useMutation(DELETE_ESGT_FOLDER);

  const deleteFolder = async (id) => {
    try {
      await deleteESGTFolder({
        variables: {
          id,
        },
        notifyOnNetworkStatusChange: true,
      });

      onFolderDelete(id);
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });
    }
  };

  const deleteFile = async (id) => {
    try {
      await deleteESGTFile({
        variables: {
          id,
        },
        notifyOnNetworkStatusChange: true,
      });

      onFileDelete(id);
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });
    }
  };

  const ShowDeleteDialog = (type, id, name) => {
    const isFile = type === "file";

    Modal.confirm({
      title: `Delete ${isFile ? "File" : "Folder"} :  ${name}`,
      okText: "Confirm",
      cancelText: "Cancel",
      onOk: () => {
        if (isFile) {
          deleteFile(id);
        } else {
          deleteFolder(id);
        }
      },
    });
  };

  return { ShowDeleteDialog };
};

useFileFolderDeleteDialog.defaultProps = {
  onFolderDelete: () => {},
  onFileDelete: () => {},
};

useFileFolderDeleteDialog.propTypes = {
  onFolderCreate: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired,
};

export default useFileFolderDeleteDialog;
